import {PureComponent, Fragment} from 'react'
import {toastr} from 'react-redux-toastr'
import {Link} from 'react-router-dom'
import connect from 'react-redux/es/connect/connect'

import BringBusinessForm from '../../components/Forms/BringBusinessForm/BringBusinessForm.jsx'
import DefaultLayout from '../Layout/DefaultLayout.jsx'
import Header from '../../components/Header/Header.jsx'
import SubmitButton from '../../components/Forms/BringBusinessForm/SubmitButton.jsx'

import api from '../../../api.js'
import conf from '../../conf.js'
import {generate} from '../../routes.js'

import './BringBusiness.scss'

class BringBusiness extends PureComponent {
  submit = async (data) => {
    try {
      return (await api.businessOpportunities.post(data))
    } catch (e) {
      toastr.error(`Nous n'avons pas pu recevoir vos éléments, veuillez nous contacter au ${conf.site.phone}`, {timeOut: 0})
      console.warn(e)
    }
  }

  onFormSuccess = (response) => {
    toastr.success(response.data.message)
  }

  render() {
    const title = "Twineeds | Programme Apport d'affaires"
    const description = "Découvrez notre programme en apport d'affaires : recommandez des entreprises, identfiez nous un besoin et générez facilement des revenus complémentaires."
    const headerBrief = <Fragment>
      <p>Vous avez connaissance d'<strong>un besoin de mission dans votre réseau ou chez un client</strong> ? Faites-le-nous savoir. Si nous concrétisons cette mission grâce à vos informations, vous recevez jusqu'à <strong><Link to={generate({name: 'bring-business-cgu', hash: '#apport-d-affaire'})} className="is-underline" target="_blank" rel="noopener noreferrer">30%</Link></strong> de notre marge commerciale.</p>
      <p>Ce programme d'<strong>apport d’affaires</strong> s’adresse à tous : freelances, consultants, salariés ou toute personne en contact avec des opportunités de mission dans nos domaines d’expertise (ingénierie, finance, achats, supply chain, RH).</p>
      <p><strong>Ce que nous attendons</strong> : des informations précises et qualifiées sur un besoin client : nom de l’entreprise, interlocuteur, contexte de la mission, profil recherché, etc.</p>
      <p><strong>Ce que vous obtenez</strong> : une rémunération directe si la mission est gagnée.</p>
      <p>Consultez les détails et conditions dans nos <strong><Link to={generate({name: 'bring-business-cgu'})} className="is-underline" target="_blank" rel="noopener noreferrer"> CGU</Link></strong>.</p>
    </Fragment>

    return <DefaultLayout id="bring-business" showSidebarMenu={false} helmet={{title, description}}>
      <Header brief={headerBrief} title="Renseignez-nous en l'échange d'une rémunération&nbsp;!"/>

      <section className="container pb-5">
        <BringBusinessForm
          initialValues={{universe: this.props.currentUniverseId}}
          onSubmit={this.submit}
          onSubmitSuccess={this.onFormSuccess}
        />
        <div className="row mt-1">
          <div className="col-md-12 text-center">
            <SubmitButton className="btn btn-primary ml-auto">Valider</SubmitButton>
          </div>
        </div>
      </section>
    </DefaultLayout>
  }
}

export default connect(
  state => ({
    currentUniverseId: state?.universe?.currentUniverse?.id ?? state?.universe?.universes?.[0]?.id
  })
)(BringBusiness)
